import { render, staticRenderFns } from "./MenuMultipleSelection.vue?vue&type=template&id=390a5745&scoped=true&"
import script from "./MenuMultipleSelection.vue?vue&type=script&lang=js&"
export * from "./MenuMultipleSelection.vue?vue&type=script&lang=js&"
import style0 from "./MenuMultipleSelection.vue?vue&type=style&index=0&id=390a5745&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390a5745",
  null
  
)

export default component.exports